module.exports = __webpack_public_path__ + "static/sound-jam-25cdedda2bcd942683e229c7815575b0.png";